import $ from 'jquery';
import core from '../core';

const CONTAINER_SELECTOR = '.js-videos-load-more';
const ROW_SELECTOR = '.js-videos-load-more__row';
const ITEM_SELECTOR = '.js-videos-load-more__item';
const BTN_SELECTOR = '.js-videos-load-more__btn';
const BTN_WRAPPER_SELECTOR = '.js-videos-load-more__btn-wrapper';
const ITEM_SHOWN_CLASS = 'is-shown';
const HIDDEN_CLASS = 'd-none';

const getRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

/**
 * Setup
 */
function setup() {
    $(document.body).on('click', BTN_SELECTOR, handleLoadMore);
}

/**
 * @param {Object} evt
 */
function handleLoadMore(evt) {
    if (evt) {
        evt.preventDefault();
    }

    const $btn = $(evt.currentTarget);
    const $btnWrapper = $btn.closest(BTN_WRAPPER_SELECTOR);
    const $container = $btn.closest(CONTAINER_SELECTOR);
    const $row = $container.find(ROW_SELECTOR);
    const total = $btn.data('total');
    const perPage = $btn.data('per-page');
    let shown = $row.find(`${ITEM_SELECTOR}.${ITEM_SHOWN_CLASS}`).length;

    console.log(shown, 'handleLoadMore :: shown');
    console.log(total, 'handleLoadMore :: total');
    console.log(perPage, 'handleLoadMore :: perPage');

    $btn.prop('disabled', true);

    getItems()
        .then(items => {
            $btn.prop('disabled', false);

            const $items = $row.find(ITEM_SELECTOR);

            for (let i = shown; i < shown + perPage; i++) {
                const $item = $items.eq(i);
                $item.fadeIn('slow', () => {
                    $item.addClass(ITEM_SHOWN_CLASS);
                });
            }

            shown = $row.find(`${ITEM_SELECTOR}.${ITEM_SHOWN_CLASS}`).length;

            if (shown === total) {
                $btnWrapper.addClass(HIDDEN_CLASS);
            } else {
                $btnWrapper.removeClass(HIDDEN_CLASS);
            }

            console.log(shown, 'total shown');
        })
        .catch(err => {
            $btn.prop('disabled', false);
            console.log(err);
        });
}

function getItems() {
    return new Promise((resolve, reject) => {
        const timeout = getRandomNumber(250, 1000);

        setTimeout(() => {
            resolve([]);
        }, timeout);
    });
}

core.Ready(setup);
